import configs from '@/config'
import Constant from '@/constant'
import { getVariant } from '@/vuex/modules/featureToggles.module'

const SET_GET_CONFIGURATION_ERROR = 'SET_GET_CONFIGURATION_ERROR'
const SET_LOADING_CONFIGURATION = 'SET_LOADING_CONFIGURATION'
const SET_CONFIGURATION = 'SET_CONFIGURATION'

const _state = {
  configuration: {},
  isLoadingConfiguration: false,
  getConfigurationError: null,
}

const getters = {
  configuration(state) {
    return state.configuration
  },
  isLoadingConfiguration(state) {
    return state.isLoadingConfiguration
  },
  getConfigurationError(state) {
    return state.getConfigurationError
  },
  isEURegion() {
    return configs.region === Constant.euRegion
  },
  announcement(_, __, ___, rootGetters) {
    const { payload } = getVariant(rootGetters, 'public-announcement')
    if (payload?.value) {
      return JSON.parse(payload.value)
    }
    return null
  },
}

const actions = {
  getConfiguration: async ({ commit }) => {
    commit(SET_LOADING_CONFIGURATION, true)
    try {
      let url = configs.configFile
      if (configs.region === 'eu') {
        url = `${configs.cloudfrontPublic}/configurations/${configs.env === 'production' ? 'config' : 'config-dev'}-eu.json`
      }
      const res = await fetch(`${url}?v=${Date.now()}`)
        .then((r) => r.json())
        .then((body) => ({ body }))
      commit(SET_CONFIGURATION, res.body)
      commit(SET_GET_CONFIGURATION_ERROR, null)
    } catch (error) {
      // Không cần làm gì kể cả khi có lỗi, có thể coi đây là lỗi từ 3rd party service khi gọi đến CloudFront Url có vấn đề, kể cả việc show thông báo lỗi cho user cũng ko cần luôn.
      // Nên có thể nuốt lỗi ở đây.
      commit(SET_GET_CONFIGURATION_ERROR, error)
    } finally {
      commit(SET_LOADING_CONFIGURATION, false)
    }
  },
}

const mutations = {
  [SET_CONFIGURATION](state, config) {
    state.configuration = config
    state.getConfigurationError = null
  },
  [SET_LOADING_CONFIGURATION](state, isLoadingConfiguration) {
    state.isLoadingConfiguration = isLoadingConfiguration
  },
  [SET_GET_CONFIGURATION_ERROR](state, error) {
    state.getConfigurationError = error
  },

}

export default {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}
